<div class="container-atendimento-real width-100 flex center-center margin-top-25">
  <div class="container-atendimento-real-interno width-80">
    <div style="min-height: 35px; height: auto; max-height: 200px;  overflow-y: auto; overflow-x: hidden">
      @if (template.variavel.corpo){
        <!-- HEADER -->
        @if (template.templateCabecalho) {
        <div class="margin-bottom-5">
          @if (template.templateCabecalho.textoOuMidia === TextoMidiaEnum.TEXTO) {
            <span class="font-10 weight-700"><strong>{{ template.templateCabecalho.titulo }}</strong></span>
          }
          @else {
            @switch (template.templateCabecalho.format){
              @case ('IMAGE'){
                <img
                  width="95%"
                  height="60%"
                  [src]="template.templateCabecalho.blob"
                  alt="Cabeçalho do template"
                >
              }
              @case ('VIDEO'){
                <video width="95%" height="60%" controls [src]="template.templateCabecalho.img" style="border: none;">
                  Seu navegador não suporta a tag de vídeo.
                </video>
              }
              @case ('DOCUMENT'){
                <iframe
                  [src]="template.templateCabecalho.blob"
                  width="95%"
                  height="60%"
                  style="border: 1px solid #ccc;">
                </iframe>
              }
              @case ('MAP'){
                <iframe
                  [src]="template.templateCabecalho.blob"
                  width="95%"
                  height="60%"
                  style="border: 1px solid #ccc;">
                </iframe>
              }
            }
          }
        </div>
        }
        <div class="flex-direction-column">
          <!-- BODY -->
          <div class="font-10 weight-600 quebra-linha" style="color: #000000">{{ texto }}</div>
          <!-- FOOTER -->
          <div class="margin-top-5">
            <span class="font-10 weight-700">{{ template.textoRodape }}</span>
          </div>

          @if (template.botoes.length > 0) {
            <div class="flex-direction-column gap-5 margin-top-10">
              @for (btn of template.botoes; track btn) {
                <app-button-padrao
                  width="100%"
                  [height]="'20px'"
                  [label]="btn.text"
                  backgroundColor="#fff"
                  color="#050000"
                  [fontSize]="'12px'">
                </app-button-padrao>
              }
            </div>
          }
        </div>
        <!-- VISUALIZACAO -->
        <div class="flex width-100 justify-end align-end margin-top-10">
          <div class="flex align-center gap-5">
            <span class="font-10 weight-600">{{ Date() | date:'hh:mm a' }}</span>
            <img width="12px" height="12px" src="./assets/icones/lido-wpp.svg" alt="Mensagem lida">
          </div>
        </div>
      }
    </div>
  </div>
</div>
